export enum MoveDirection {
  Up = 'up',
  Down = 'down',
}